import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'

@Injectable()
export class SystemAdminEffects {
  constructor(private actions$: Actions) {}
}
